import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const testimonials = [
    {
        image: require('./../../images/testimonials/pic1.jpg'),
        reviewername: 'Abdul Hafeez',
        position: 'Project Manager, DWP Group',
        review: 'Buildco Associates transformed our commercial building into a stunning, high-performance space. Their attention to structural detail and superior interior finishing exceeded every expectation. Truly a world-class team.'
    },
    {
        image: require('./../../images/testimonials/pic2.jpg'),
        reviewername: 'Anila Farhat',
        position: 'Director, Tariq Properties — Islamabad',
        review: 'From foundation to final furnishing, Buildco handled every phase with exceptional professionalism. Our office renovation was delivered on schedule and within budget. Their team is disciplined, skilled, and results-driven.'
    },
    {
        image: require('./../../images/testimonials/pic3.jpg'),
        reviewername: 'Gulzar Ahmed',
        position: 'Property Manager, DHA Phase 2 Islamabad',
        review: 'The structured cabling and computer networking infrastructure Buildco installed across our residential complex is flawless. Seamless connectivity, clean execution, and zero downtime — a truly professional technical team.'
    },
    {
        image: require('./../../images/testimonials/pic4.jpg'),
        reviewername: 'Imran Malik',
        position: 'General Manager, Meezan Bank — Blue Area',
        review: 'Buildco delivered a modern banking interior that is both professional and welcoming. Their spatial planning expertise and commitment to deadlines made the entire branch fit-out completely stress-free.'
    },
    {
        image: require('./../../images/testimonials/pic5.jpg'),
        reviewername: 'Muhammed Bilal',
        position: 'CEO, T&J Group',
        review: "Build Co team brought a perfect blend of craftsmanship and creativity to our textile company office. The interior not only looks stunning but also supports our daily operations seamlessly. "
    }

]

var bnr1 = require('./../../images/background/bg6.jpg');

class Testimonials extends React.Component {
    render() {

        const options = {
            loop: true,
            autoplay: true,
            margin: 30,
            nav: false,
            dots: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: {
                    items: 1
                },
                991: {
                    items: 2
                }
            }
        };

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b50 square_shape2 bg-cover" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                    <div className="container">
                        <div className="section-content">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span>What</span><span className="font-weight-300 text-primary"> Client’s </span>say about Our Services</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            {/* TESTIMONIAL START */}
                            <OwlCarousel className="owl-carousel testimonial-home" {...options}>

                                {testimonials.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="testimonial-2 m-a30 hover-animation-1">
                                            <div className=" block-shadow bg-white p-a30">
                                                <div className="testimonial-detail clearfix">
                                                    <div className="testimonial-pic radius shadow scale-in-center"><img src={item.image} width={100} height={100} alt="" /></div>
                                                    <h4 className="testimonial-name m-b5">{item.reviewername} -</h4>
                                                    <span className="testimonial-position">{item.position}</span>
                                                </div>
                                                <div className="testimonial-text">
                                                    <span className="fa fa-quote-right" />
                                                    <p> {item.review}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>


                        </div>
                    </div>

                </div>
            </>
        );
    }
};

export default Testimonials;